/* eslint @typescript-eslint/naming-convention: [
    'error',
    {
      "selector": "variable",
      "format": ["PascalCase", "UPPER_CASE"],
      "leadingUnderscore": "forbid",
      "trailingUnderscore": "forbid"
    }
  ]
*/

export enum LightEvents {
  MANIFEST_LIGHTS_ADDED = 'MANIFEST_LIGHTS_ADDED',
  LIGHT_DESTROYED = 'LIGHT_DESTROYED',
  SHADOWS_HIDDEN = 'SHADOWS_HIDDEN',
  SHADOWS_SHOWN = 'SHADOWS_SHOWN',
}

export enum ManifestHandlerEvents {
  MANIFEST_LOADED = 'MANIFEST_LOADED',
}

export enum PerspectiveEvents {
  PERSPECTIVE_CHANGE_START = 'PERSPECTIVE_CHANGE_START',
  PERSPECTIVE_CHANGE_END = 'PERSPECTIVE_CHANGE_END',
  ANGLE_RESTRICTION_SET = 'ANGLE_RESTRICTION_SET',
  ZOOM_RESTRICTION_SET = 'ZOOM_RESTRICTION_SET',
  RESET_VIEW = 'RESET_VIEW',
  CAMERA_POSITION_CHANGE = 'CAMERA_POSITION_CHANGE',
  CAMERA_TARGET_CHANGE = 'CAMERA_TARGET_CHANGE',
}

export enum HotspotEvents {
  HOTSPOT_CLICKED = 'HOTSPOT_CLICKED',
  HOTSPOT_CREATED = 'HOTSPOT_CREATED',
  HOTSPOT_TARGET_CREATED = 'HOTSPOT_TARGET_CREATED',
  HOTSPOT_POINTER_LEAVE = 'HOTSPOT_POINTER_LEAVE',
  HOTSPOT_POINTER_ENTER = 'HOTSPOT_POINTER_ENTER',
  HOTSPOT_SHOW = 'HOTSPOT_SHOW',
  HOTSPOT_HIDE = 'HOTSPOT_HIDE',
  GIZMO_MOVE_HOTSPOT = 'GIZMO_MOVE_HOTSPOT',
  HOTSPOT_DESTROYED = 'HOTSPOT_DESTROYED',
  HOTSPOT_TARGET_DESTROYED = 'HOTSPOT_TARGET_DESTROYED',
}
